import React from 'react';

const EpmTooltip = ({ content, children, className = '' }) => {
    return (
        <details className={`epm-tip ${className}`.trim()}>
            <summary>
                {children || 'i'}
                <span className="bub">{content}</span>
            </summary>
        </details>
    );
};

export default EpmTooltip;